export default __webpack_public_path__ + "a2246c976974d9ac2c8d756fed64692b.gif";